import React from 'react';
import errorAnimationData from 'assets/error.json';
import DefaultFace from './DefaultFace.js';

const ErrorFace = ({
  onClick,
  headerText = 'headerText',
  bodyText = 'bodyText',
  buttonText = 'buttonText',
  onSecondaryClick,
  secondaryButtonText,
  background,
}) => {
  return (
    <DefaultFace
      onClick={onClick}
      animationData={errorAnimationData}
      headerText={headerText}
      bodyText={bodyText}
      buttonText={buttonText}
      onSecondaryClick={onSecondaryClick}
      secondaryButtonText={secondaryButtonText}
      background={background}
    />
  );
};

export default ErrorFace;
